export default function createEnvConfig(entries = {}) {
  var prodConfig = {
    API_URL_ORIGIN: 'https://api.mapbox.com'
  };

  var stagingConfig = {
    API_URL_ORIGIN: 'https://cloudfront-staging.tilestream.net'
  };

  Object.keys(entries).forEach(function(id) {
    prodConfig[id] = entries[id].production;
    stagingConfig[id] = entries[id].staging;
  });

  if (process.env.DEPLOY_ENV === 'production') {
    return prodConfig;
  } else {
    return stagingConfig;
  }
}
